'use es6';

import { stringify } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
import Categories from './constants/Categories';
import DesignAssetTypes from './constants/DesignAssetTypes';
import enviro from 'enviro';
import { getIconUrl } from 'content-icons-ui/iconUrl';
import { ICON_SETS, DEFAULT_ICON_SET } from 'ContentUtils/constants/IconSets';
import { PREVIEW_DOMAINS } from './constants/Domains';
var SITE_PAGE_SUBCATEGORIES = ['site_page', 'mab_site_page_master', 'mab_site_page_variant'];

var isSitePage = function isSitePage(subcategoryId) {
  return typeof subcategoryId === 'string' && SITE_PAGE_SUBCATEGORIES.includes(subcategoryId.toLowerCase());
}; // Used to allow returning to original page whne navigating to a settings page.


var ESHREF_PARAM = "eschref=" + encodeURIComponent(window.location.pathname);
var Routes = {
  gates: null,
  optinMap: {},
  hasInitialized: false,
  init: function init(nextGates) {
    var optinMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Routes.gates = nextGates;
    Routes.optinMap = optinMap;
    Routes.hasInitialized = true;
  },
  isUngated: function isUngated(gateName) {
    if (!Array.isArray(Routes.gates)) {
      throw new Error('Routes needs to be initialized with an array of gates before using');
    }

    return Routes.gates.indexOf(gateName) > -1;
  },
  isOptedIn: function isOptedIn(optinName) {
    if (!Routes.optinMap) {
      throw new Error('Initialized map with falsey value');
    }

    return !!Routes.optinMap[optinName];
  },
  dashboard: function dashboard(categoryId, subcategoryId, parentId) {
    var category = Categories[categoryId];
    var slug = category.api_slug;

    if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name)) {
      if (category.field_name === 'site_page' || isSitePage(subcategoryId)) {
        return "/website/" + PortalIdParser.get() + "/pages/site";
      } else if (category.field_name === 'landing_page') {
        return "/website/" + PortalIdParser.get() + "/pages/landing";
      } else if (category.field_name === 'blog_post') {
        var baseUrl = "/website/" + PortalIdParser.get() + "/blog/posts";
        return parentId ? baseUrl + "?blog=" + parentId : baseUrl;
      }

      return "/website/" + PortalIdParser.get();
    }

    if (isSitePage(subcategoryId)) {
      slug = Categories.site_page.api_slug;
    }

    if (category.field_name === 'email') {
      return Routes.emailDashboard();
    }

    return "/content/" + PortalIdParser.get() + "/" + slug;
  },
  blogImporter: function blogImporter() {
    return "/content/" + PortalIdParser.get() + "/blog-import";
  },
  siteImporter: function siteImporter() {
    return "/site-importer/" + PortalIdParser.get() + "/blog-import/dashboard";
  },
  emailDashboard: function emailDashboard() {
    return "/email/" + PortalIdParser.get() + "/manage";
  },
  // categoryId can be category_id int or python's Category.field_name (email|blog_post|landing_page)
  edit: function edit(contentId, categoryId) {
    return Routes.inpageEdit(contentId, categoryId);
  },
  editDragDropEmail: function editDragDropEmail(contentId) {
    return this.editEmail(contentId);
  },
  editEmail: function editEmail(contentId) {
    return "/email/" + PortalIdParser.get() + "/edit/" + contentId;
  },
  inpageEdit: function inpageEdit(contentId, categoryId) {
    var category = Categories[categoryId] || {};

    switch (category.field_name) {
      case 'blog_post':
        return "/blog/" + PortalIdParser.get() + "/edit-beta/" + contentId;

      case 'email':
        if (this.isOptedIn('mergedEmailEditor') && this.isUngated('Email:MergedEditorOptinSwitch')) {
          return this.editEmail(contentId);
        }

        return "/email/" + PortalIdParser.get() + "/edit-beta/" + contentId;

      default:
        return "/content/" + PortalIdParser.get() + "/edit/" + contentId;
    }
  },
  details: function details(contentId, categoryId, subcategory) {
    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      tab: 'performance'
    },
        _ref$tab = _ref.tab,
        tab = _ref$tab === void 0 ? 'performance' : _ref$tab;

    var urlParamsString = params ? "?" + stringify(params) : '';
    var category = Categories[categoryId];

    if (category.field_name === 'unmapped') {
      return "/content-detail/" + PortalIdParser.get() + "/external-page/optimization" + urlParamsString;
    } else if (['site_page', 'landing_page', 'blog_post'].includes(category.field_name)) {
      var slugSource = isSitePage(subcategory) ? Categories['site_page'] : category;
      return "/content-detail/" + PortalIdParser.get() + "/" + slugSource.slug_singular + "/" + contentId + "/" + tab + urlParamsString;
    } else if (category.field_name === 'email') {
      return "/email/" + PortalIdParser.get() + "/details/" + contentId + "/" + tab + urlParamsString;
    } else if (category.field_name === 'knowledge_article') {
      return "/knowledge/" + PortalIdParser.get() + "/insights/article/" + contentId + "/" + tab + urlParamsString;
    }

    return "/content-detail/" + PortalIdParser.get() + "/landing-page/" + contentId + "/" + tab + urlParamsString;
  },
  staging: function staging() {
    return "/content/" + PortalIdParser.get() + "/staging";
  },
  stagingBeta: function stagingBeta(domainId) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/manage';
    return this.staging(domainId, route);
  },
  cta: function cta() {
    return "/cta/" + PortalIdParser.get();
  },
  ctaDetails: function ctaDetails(placementGuid) {
    return "/cta/" + PortalIdParser.get() + "/" + placementGuid;
  },
  ctaSmartRules: function ctaSmartRules(placementGuid) {
    return "/content/" + PortalIdParser.get() + "/cta/" + placementGuid;
  },
  templateSwap: function templateSwap(categoryId, contentId) {
    if (!contentId) {
      throw new Error('A content id is required for template swap');
    }

    var category = Categories[categoryId];

    if (category.slug_singular === 'site-page' || category.slug_singular === 'landing-page') {
      return "/create/" + PortalIdParser.get() + "/" + category.slug_singular + "/your-themes?contentId=" + contentId + "&referrer=editpage";
    }

    throw new Error('Themed template swap can only used for pages');
  },
  create: function create(categoryId, subcategory) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref2$isMarketingStar = _ref2.isMarketingStarterPortal,
        isMarketingStarterPortal = _ref2$isMarketingStar === void 0 ? false : _ref2$isMarketingStar,
        _ref2$hasThemedConten = _ref2.hasThemedContentCreatorAccess,
        hasThemedContentCreatorAccess = _ref2$hasThemedConten === void 0 ? false : _ref2$hasThemedConten,
        _ref2$moduleIdForRevi = _ref2.moduleIdForReviewingDependents,
        moduleIdForReviewingDependents = _ref2$moduleIdForRevi === void 0 ? null : _ref2$moduleIdForRevi,
        _ref2$moduleName = _ref2.moduleName,
        moduleName = _ref2$moduleName === void 0 ? '' : _ref2$moduleName;

    var category = isSitePage(subcategory) ? Categories.site_page : Categories[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    if (category.slug_singular !== 'email' && hasThemedContentCreatorAccess && Routes.isUngated('cms-themed-content-creator')) {
      return "/create/" + PortalIdParser.get() + "/" + category.slug_singular;
    }

    var createUrl = "/content/" + PortalIdParser.get() + "/create/" + category.slug_singular;

    if (category.slug_singular !== 'email' && isMarketingStarterPortal) {
      return createUrl + "/starter";
    }

    if (category.slug_singular === 'email') {
      if (moduleIdForReviewingDependents) {
        return createUrl + "?subcategory=drag_drop_email&moduleId=" + moduleIdForReviewingDependents + "&moduleName=" + moduleName;
      } else if (subcategory === 'drag_drop_email') {
        return createUrl + "?subcategory=drag_drop_email";
      }
    }

    return createUrl;
  },
  createNew: function createNew(categoryId, subcategory, name, templatePath) {
    /* Create new only available in create-beta */
    var portalId = PortalIdParser.get();
    var category = subcategory === 'landing_page' ? Categories.landing_page : Categories[categoryId];

    if (category.slug_singular === 'blog-post') {
      throw new Error('Create page only used for pages & emails');
    }

    return "/content/" + portalId + "/create/" + category.slug_singular + "/new?name=" + name + "&templatePath=" + templatePath;
  },
  settings: function settings(subsection) {
    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var portalId = PortalIdParser.get();
    var baseURL = "/settings/" + portalId + "/";

    switch (subsection) {
      case 'email':
        {
          var emailBase = baseURL + "marketing/email/";

          switch (tab) {
            case 'frequency':
              return emailBase + "frequency";

            case 'subscriptions':
              return emailBase + "subscriptions";

            case 'types':
              return emailBase + "types";

            case 'tracking':
              return emailBase + "tracking";

            case 'double-opt-in':
              return emailBase + "double-opt-in";

            default:
              return emailBase;
          }
        }

      case 'blog':
        {
          return baseURL + "website/blogs" + (tab ? "/" + tab : '');
        }

      case 'publishing':
        {
          return baseURL + "website/pages";
        }

      case 'users':
        return baseURL + "users";

      case 'domains':
        {
          if (tab === 'languageSettings') {
            return baseURL + "marketing/domains/languageSettings";
          }

          return "/domains/" + portalId;
        }

      case 'themes':
        return baseURL + "website/themes";

      default:
        return baseURL;
    }
  },
  privateContentSettings: function privateContentSettings(tab) {
    var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all-domains';
    return "/settings/" + PortalIdParser.get() + "/content-membership/" + domain + "/" + tab;
  },
  systemPagesSettings: function systemPagesSettings(domain) {
    var basePagesUrl = Routes.settings('publishing');

    var __domain = domain || "all-domains";

    return basePagesUrl + "/" + __domain + "/system-pages?" + ESHREF_PARAM;
  },
  logoSettings: function logoSettings(domain) {
    var portalId = PortalIdParser.get();

    var __domain = domain || "all-domains";

    return "/settings/" + portalId + "/website/pages/" + __domain + "/branding?" + ESHREF_PARAM;
  },
  blogSpecificSettings: function blogSpecificSettings(blogId) {
    var subTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Routes.settings('blog') + "/" + blogId + subTab + "?" + ESHREF_PARAM;
  },
  advancedMenuSettings: function advancedMenuSettings(menuId, redirectUrl) {
    var basePath = "/menus/" + PortalIdParser.get() + "/edit/" + menuId;

    if (redirectUrl) {
      return basePath + "?redirectUrl=" + encodeURIComponent(redirectUrl);
    }

    return basePath;
  },
  advancedMenuAddPage: function advancedMenuAddPage(pageId) {
    return "/content/" + PortalIdParser.get() + "/settings/menus/add-page?contentId=" + pageId + "&" + ESHREF_PARAM;
  },
  designManager: function designManager(assetId, assetType, assetSource, path) {
    var route = "/design-manager/" + PortalIdParser.get();

    if (assetId && assetType) {
      var urlPath;

      switch (assetType) {
        case DesignAssetTypes.LAYOUT:
        case DesignAssetTypes.GLOBAL_GROUP:
          {
            urlPath = "templates/" + assetId;
            break;
          }

        case DesignAssetTypes.TEMPLATE:
          {
            if (assetSource === 'HOLLOW') {
              urlPath = "code/p/" + path;
            } else {
              urlPath = "code/" + assetId;
            }

            break;
          }

        case DesignAssetTypes.CUSTOM_WIDGET:
          {
            urlPath = "modules/" + assetId;
            break;
          }

        case DesignAssetTypes.GLOBAL_WIDGET:
          {
            urlPath = "global-modules/" + assetId;
            break;
          }

        default:
          {
            throw new Error("Invalid Design Manager assetType provided. Received '" + assetType + "'.");
          }
      }

      route = route + "/" + urlPath;
    }

    return route;
  },
  globalContent: function globalContent(moduleId) {
    if (moduleId) {
      return Routes.designManager(moduleId, DesignAssetTypes.GLOBAL_WIDGET);
    }

    if (Routes.isUngated('DesignManagerUI:GlobalContent:Redirect')) {
      return Routes.designManager() + "?referrer=global-content";
    }

    return "/content/" + PortalIdParser.get() + "/global-content";
  },
  fileManager: function fileManager(folderPath, params) {
    var path = "/files/" + PortalIdParser.get();

    if (folderPath) {
      path = path + "/folder/" + folderPath.replace(/^\//, '');
    }

    if (params) {
      path = path + "?" + stringify(params);
    }

    return path;
  },
  hubdb: function hubdb() {
    return "/hubdb/" + PortalIdParser.get();
  },
  hubdbTable: function hubdbTable(tableId) {
    return this.hubdb() + "/table/" + tableId;
  },
  workflows: function workflows(workflowId) {
    var workflowType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'WORKFLOWS';

    if (workflowType === 'AUTOMATION_PLATFORM') {
      return "/workflows/" + PortalIdParser.get() + "/platform/flow/" + workflowId + "/edit";
    }

    return "/contacts/" + PortalIdParser.get() + "/automation/flow/" + workflowId + "/edit/";
  },
  workflowsDashboard: function workflowsDashboard() {
    return "/contacts/" + PortalIdParser.get() + "/automation";
  },
  contact: function contact(vid) {
    return "/contacts/" + PortalIdParser.get() + "/contact/" + vid;
  },
  deal: function deal(dealId) {
    return "/contacts/" + PortalIdParser.get() + "/deal/" + dealId;
  },
  forms: function forms(formId, redirectUrl) {
    var extraParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var basePath = "/forms/" + PortalIdParser.get() + "/editor/" + formId + "/edit/form";
    var params = Object.assign({}, extraParams, {}, redirectUrl ? {
      redirectUrl: redirectUrl,
      isExternalEditor: 'cos'
    } : {});
    var paramsAsString = stringify(params);
    return paramsAsString.length > 0 ? basePath + "?" + paramsAsString : basePath;
  },
  salesforceCampaigns: function salesforceCampaigns() {
    return "/integrations-beta/" + PortalIdParser.get() + "/your-integrations/salesforce";
  },
  domainManager: function domainManager() {
    return "/domains/" + PortalIdParser.get();
  },
  leadFlowFollowup: function leadFlowFollowup(leadFlowId) {
    return "/lead-flows/" + PortalIdParser.get() + "/edit/" + leadFlowId + "/follow-up";
  },
  formFollowup: function formFollowup(formId) {
    return "/forms/" + PortalIdParser.get() + "/editor/" + formId + "/edit/followUp";
  },
  emailCompare: function emailCompare() {
    var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (ids.length > 0) {
      return "/email/" + PortalIdParser.get() + "/compare?id=" + ids.join('&id=');
    }

    return "/email/" + PortalIdParser.get() + "/compare";
  },
  surveyEditor: function surveyEditor(surveyType, surveyId) {
    var surveyTypePath = {
      CES: 'support',
      NPS: 'loyalty',
      CSAT: 'satisfactions'
    }[surveyType];
    return "/feedback-editor/" + PortalIdParser.get() + "/" + surveyTypePath + "/" + surveyId;
  },
  marketplace: function marketplace(urlToken, redirectUrl) {
    var marketplaceRoute = "/marketplace/" + PortalIdParser.get();
    return urlToken ? marketplaceRoute + "/products/" + urlToken + (redirectUrl ? "?redirectUrl=" + encodeURIComponent(redirectUrl) : '') : marketplaceRoute;
  },
  marketingHubPricingPage: function marketingHubPricingPage() {
    return "/pricing/" + PortalIdParser.get() + "/products/marketing";
  },
  compareMarketingProducts: function compareMarketingProducts(product) {
    var portalId = PortalIdParser.get();
    var queryString = '';

    if (product) {
      queryString = "?product=" + product;
    }

    return "/browse/" + portalId + "/compare/marketing" + queryString;
  },
  accountSummary: function accountSummary() {
    var portalId = PortalIdParser.get();
    return "/account-and-billing/" + portalId + "/products";
  },
  accountUsage: function accountUsage() {
    var portalId = PortalIdParser.get();
    return "/account-and-billing/" + portalId + "/usage";
  },
  additionalContact: function additionalContact() {
    var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var portalId = PortalIdParser.get();
    return "/pricing/" + portalId + "/confirm-contacts" + queryParams;
  },
  campaignDetails: function campaignDetails(campaignId) {
    var portalId = PortalIdParser.get();
    return "/campaigns/" + portalId + "/" + campaignId;
  },
  goToWebinar: function goToWebinar() {
    return "/integrations-beta/" + PortalIdParser.get() + "/your-integrations/gotowebinar";
  },
  list: function list(listId) {
    return "/contacts/" + PortalIdParser.get() + "/lists/" + listId;
  },
  lists: function lists() {
    // Not lists UI but CRM contact filter view
    return "/contacts/" + PortalIdParser.get() + "/contacts/list/view/all";
  },
  newList: function newList() {
    return "/contacts/" + PortalIdParser.get() + "/lists/create";
  },
  getPreviewDomain: function getPreviewDomain() {
    var env = enviro.getShort('preview');

    if (env !== 'local') {
      return PREVIEW_DOMAINS[env];
    }

    try {
      return localStorage.getItem('PREVIEW_DOMAIN') || PREVIEW_DOMAINS[env];
    } catch (e) {
      return PREVIEW_DOMAINS[env];
    }
  },
  getPreviewUrl: function getPreviewUrl(contentId, extraParams) {
    var env = enviro.getShort('preview');
    var params = Object.assign({
      portalId: PortalIdParser.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "?" + stringify(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "?" + stringify(params);
  },
  getVideoPreviewUrl: function getVideoPreviewUrl(playerId, extraParams) {
    var params = Object.assign({
      portalId: PortalIdParser.get()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();
    return "https://" + previewDomain + "/content-rendering/v1/internal/preview/player/" + playerId + "?" + stringify(params);
  },
  getPreviewSidebarUrl: function getPreviewSidebarUrl(contentId, extraParams) {
    var env = enviro.getShort('preview');
    var params = Object.assign({
      portalId: PortalIdParser.get(),
      _preview: true,
      cacheBust: Date.now()
    }, extraParams);
    var previewDomain = this.getPreviewDomain();

    if (env === 'local') {
      return "https://" + previewDomain + "/cos-rendering/v1/public/_hcms/preview/content/" + contentId + "/sidebar?" + stringify(params);
    }

    return "https://" + previewDomain + "/_hcms/preview/content/" + contentId + "/sidebar?" + stringify(params);
  },
  themes: function themes() {
    return this.settings('themes') + "?" + ESHREF_PARAM;
  },
  themeEditor: function themeEditor(themePath, params) {
    var route = "/theme-editor/" + PortalIdParser.get() + "/edit/" + themePath;
    if (params) route = route + "?" + stringify(params);
    return route;
  },
  globalContentEditor: function globalContentEditor(globalContentId, params) {
    var _ref3 = params || {},
        assetPath = _ref3.assetPath;

    if (!(globalContentId || assetPath)) {
      throw new Error('Global content ID or asset path required to load editor.');
    }

    var route = "/global-content-editor/" + PortalIdParser.get() + "/edit";
    if (globalContentId) route = route + "/" + globalContentId;
    if (params) route = route + "?" + stringify(params);
    return route;
  },
  createTeamMeeting: function createTeamMeeting() {
    return "/meetings/" + PortalIdParser.get() + "/team/new";
  },
  createPersonalMeeting: function createPersonalMeeting() {
    return "/meetings/" + PortalIdParser.get() + "/personal/new";
  },
  editMeeting: function editMeeting(portalId, meetingId) {
    return "/meetings/" + portalId + "/personal/" + meetingId;
  },
  getContentIconsUrl: function getContentIconsUrl(set, iconName, style) {
    if (!set || !ICON_SETS[set]) set = DEFAULT_ICON_SET;
    return getIconUrl(set, iconName, style);
  },
  blogDashboard: function blogDashboard(contentGroupId) {
    if (contentGroupId) {
      return "/blog/" + PortalIdParser.get() + "/blogs/posts?blog=" + contentGroupId;
    }

    return "/blog/" + PortalIdParser.get();
  },
  accountDefaults: function accountDefaults(path) {
    return "/settings/" + PortalIdParser.get() + "/account-defaults/" + path;
  }
};
export default Routes;